<form #mainFrm="ngForm" class="full layout-col">
  <elder-table class="flex" matSort [data]="data" [idField]="'itemId'">
    <!-- Pos numbers Column -->
    <ng-container matColumnDef="ids">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.number' | translate }}</th>
      <td mat-cell *matCellDef="let grouped">
        @for (traced of grouped?.tracedMaterials; track traced) {
          <span class="layout-col">
            {{ traced.itemInfo?.number }}
          </span>
        }
      </td>
    </ng-container>

    <!-- Distinct Materials Column -->
    <ng-container matColumnDef="materials">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.material' | translate }}
      </th>
      <td mat-cell *matCellDef="let grouped">
        @for (matInfo of grouped?.distinctMaterialInfo; track matInfo) {
          <span class="layout-col">
            <div class="layout-col">
              <span>{{ matInfo?.id }} ({{ matInfo?.searchTerm }})</span>
              <span class="mat-caption">{{ matInfo?.path }} </span>
            </div>
          </span>
        }
      </td>
    </ng-container>

    <!-- Config Column -->
    <ng-container matColumnDef="config">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.config' | translate }}</th>
      <td mat-cell *matCellDef="let grouped">
        <app-batch-tracing-conf-detail [spec]="grouped.spec" [conf]="grouped.conf">
        </app-batch-tracing-conf-detail>
      </td>
    </ng-container>
  </elder-table>

  <div class="layout-row place-start-center gap-sm p-sm">
    <button mat-button [disabled]="!mainFrm.valid" (click)="onConfirmTracingConfig()">
      {{ 'actions.ok' | translate }}
    </button>
  </div>
</form>
